/**
 * Provides details about widgets for the builder.
 */

import { sections } from '.';

export const manifest = Object.keys(sections).map((sectionName) => {
  const { details } = sections[sectionName];

  return {
    type: sectionName,
    name: `${sectionName} Section`,
    ...details,
    hidden: details.deprecated || details.hidden,
  };
});

export const enabledFlippers = manifest.reduce((prev, { flipper }) => {
  if (flipper && !prev.find(item => item === flipper)) {
    prev.push(flipper);
  }
  return prev;
}, []);
